import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { filter, map, mergeMap } from 'rxjs';
import { SEOService } from './core/shared-services/SEO.service';
import { GtmService } from './core/shared-services/gtm.service';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    animations   : fuseAnimations,
    imports    : [RouterOutlet, MatButtonModule, MatIconModule],
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private _seoService: SEOService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private gtmService: GtmService
    ){}

    ngOnInit() {

        if (isPlatformBrowser(this.platformId)) {
            this.gtmService.initGtm();
        }

        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
              while (route.firstChild) route = route.firstChild;
              return route;
            }),
            filter((route) => route.outlet === 'primary'),
            mergeMap((route) => route.data)
           )
           .subscribe((event) => {
                this._seoService.updateTitle(event['title']);
                this._seoService.updateDescription(event['title'] + event['description']);
                this._seoService.updateKeywords(event['keywords']);

                this._seoService.updateOgTitle(event['ogTitle']);
                this._seoService.updateOgType(event['ogType']);
                this._seoService.updateOgDescription(event['ogDescription']);
                this._seoService.updateOgImage(event['ogImage']);
                this._seoService.updateOgUrl(event['ogUrl']);

                this._seoService.updateTwitterCard(event['twCard']);
                this._seoService.updateTwitterTitle(event['twTitle']);
                this._seoService.updateTwitterDescription(event['twDescription']);
                this._seoService.updateTwitterImage(event['twImage']);

                this._seoService.updateCanonical(event['canonical']);

                //  GO TO TOP OF PAGE
                if (isPlatformBrowser(this.platformId)) {
                    this.trackPageViews()
                    window.scroll({ 
                        top: 0, 
                        left: 0, 
                        behavior: 'smooth' 
                    });
                }
           });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Whatsapp redirection
     */
    public redirectToWhatsApp() {
        if (isPlatformBrowser(this.platformId)) {
            window.open('https://api.whatsapp.com/send/?phone=0600687377&text=Please+can+you+assist+me', '_blank');
        }
    }

    private trackPageViews(): void {
        this.router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            (window as any).gtag?.('config', 'GTM-MBHQ44Z3', { page_path: event.urlAfterRedirects });
          }
        });
      }
}
